import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fetchProductErrorToastDescription: {
    id: 'modules.CatalogV2.pages.Product.fetchProductErrorToastDescription',
    defaultMessage: 'Ocorreu um erro ao carregar o produto',
  },
});

export default messages;
